import noUiSlider from 'nouislider'

export default function initInputRange() {
  let sliders = document.querySelectorAll('.range-slider');
  if (!sliders) return;
  let rangeSliderItems = [];

  sliders.forEach(slider => {
    var stepsSlider = slider.querySelector('.range-slider__steps');
    var input0 = slider.querySelector('.range-slider__input-0');
    var input1 = slider.querySelector('.range-slider__input-1');
    var inputs = [input0, input1];
    let min = stepsSlider.getAttribute('data-range-min') ? Number(stepsSlider.getAttribute('data-range-min')) : 0;
    let max = stepsSlider.getAttribute('data-range-max') ? Number(stepsSlider.getAttribute('data-range-max')) : 200;
    let rangeStep = stepsSlider.getAttribute('data-range-step') ? Number(stepsSlider.getAttribute('data-range-step')) : 100;

    const sliderInstance = noUiSlider.create(stepsSlider, {
        start: [min, max],
        connect: true,
        step: rangeStep,
        tooltips: false,
        range: {
            'min': min,
            'max': max
        }
    });

    function formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    };

    stepsSlider.noUiSlider.on('update', function (values, handle) {
      const spanValueMin = document.querySelector('.price-view .min-price-view .price');
      const spanValueMax = document.querySelector('.price-view .max-price-view .price');
      inputs[handle].value = Math.round(values[handle]);
      spanValueMin.innerHTML = formatNumber(input0.value);
      spanValueMax.innerHTML = formatNumber(input1.value);
      input0.dispatchEvent(new Event('change'));
      input1.dispatchEvent(new Event('change'));
    });

    rangeSliderItems.push(sliderInstance);
    window.RangeSliders = rangeSliderItems;
  })
}
